<template lang="pug">
.detail.h-100
  .mx-4.my-2.px-3.pt-3
    .d-flex
      .d-flex.text-large.mr-4
        | รายการขายเลขที่
        FormattedEntryNo.ml-2(
          :entryNo='entryDetail.entryNo'
          :orderId='entryDetail.id'
        )
      .text-large.mr-4
        | {{ formattedDate }}
        | เวลา {{ formattedTime }}
      CustomStatusBadge(
        :status='entryDetail.status'
        type='ORDER_STATUS'
      )
      //- button.btn.btn-secondary.ml-auto
      //-   | แก้ไขรายการ

    .d-flex.align-items-start.mt-2.pt-4.pb-3
      CSCustomerCompactDetailHeader(:data='customer')
      div.ml-auto.mr-4
        .d-flex
          div
            .d-flex
              .text-large.mr-3
                | จัดส่งหน้าร้าน
              CustomStatusBadge(
                :status='entryDetail.shipmentStatus'
                type='SHIPMENT_STATUS'
              )

            .text-small
              | เลขที่ใบสั่งซื้อจากลูกค้า
              | {{ entryDetail.customer_po_no ? entryDetail.customer_po_no : '-' }}

            .text-small.text-danger(v-if="entryDetail.warehouse_id !== null")
              | เปลี่ยนคลังเป็น {{warehouseName}}

          div.ml-4.pl-2
            .text-small ผู้ทำรายการขาย
            .text-medium.text-bold
              template(v-if='entryDetail && entryDetail.user')
                | {{ entryDetail.user.name }}

        CSCustomerBasicStat.mt-4.pt-2(
          :data='customer'
        )

  CSCustomerExtendedStat(
    :data='customer'
    :grade='customer.grade'
    :order='{total: total}'
  )

  .d-flex.px-4.py-2
    .text-large รายการสินค้า
    LoadingIndicator.ml-2(v-if='isLoading')
  hr.m-0

  template(v-if='entryDetail')
    .px-4.pt-2
      //- div {{ JSON.stringify(entryDetail) }}
      CustomTable(
        :columns='tableColumns'
        :data='tableData'
        :itemClickable='false'
      )
    .sticky-bottom.bg-white
      hr.m-0
      .d-flex.justify-content-between.mx-3.px-4.py-2
        .d-flex
          div หมายเหตุ:
          template(v-if='entryDetail.remarks || entryDetail.internal_message')
            ol
              li(v-if='entryDetail.remarks')
                | {{ entryDetail.remarks }}
              li(v-if='entryDetail.internal_message')
                | {{ entryDetail.internal_message }}
          template(v-else)
            .ml-4 -
        .d-flex.flex-column.align-items-end
          .text-xlarge
            span.mr-3 รวมค่าสินค้าทั้งสิ้น
            span.ml-4 {{ total | currency }}
          //- .text-xlarge
          //-   span.mr-3 รวมค่าคอมมิชชั่นที่ได้รับ
          //-   span.ml-4 {{ (1320.00) | currency }}
      template(v-if="!isConditionPassed")
        p.my-1.text-center.text-danger * มีเงื่อนไขสำคัญที่ไม่ผ่าน *
      template(v-if='entryDetail.status === $api.customer.ORDER_STATUS.PENDING')
        .dialog-button-bar.d-flex.justify-content-center.py-4
          button.btn.btn-upa-warning(@click='rejectSell')
            | ไม่อนุมัติรายการขาย
          button.btn.btn-upa-success.ml-3(@click='approveSell')
            | อนุมัติรายการขาย
          button.btn.btn-secondary.ml-3(@click='sendToCS')
            | ส่งกลับ CS

    Modal(
      name='action-to-back-order'
      width='540px' height='480px'
      transition='modal-transition'
      :clickToClose='true'
    )
      .p-4
        p.h4.text-center.text-danger อนุมัติไม่สำเร็จ
        p.h6.text-center.text-danger เนื่องจากมีสินค้าที่ไม่พอในรายการ
        CustomTable(
          :columns='failedApprovalItemsColumns'
          :data='failedApprovalItems'
          :itemClickable='false'
        )
        .dialog-button-bar.d-flex.justify-content-center.py-4
          div
            button.btn.ml-3.btn-secondary(
              @click="$modal.hide('action-to-back-order')")
              | กลับไปแก้ไข
          div(v-if="failedApprovalItems.filter((e) => e.remaining === 0).length === 0")
            button.btn.btn-upa-warning.ml-3(@click='approveSellForce')
              | เปิดเท่าที่มี
            br
            p.mt-2: small ส่วนที่ขาดจะปัดเป็น back order
          div.px-4.text-center(v-else): small
            | มีรายการที่เหลือ 0 หน่วย
            br
            | จำเป็นต้องกลับไปแก้ไขในออเดอร์

    Modal(
      name='action-status'
      width='480px' height='480px'
      transition='modal-transition'
      :clickToClose='false'
    )
      StatusDialog(
        :type='actionStatusType'
        @closeButtonClicked='onModalCloseButtonClicked'
      )

</template>

<script>
import CSCustomerCompactDetailHeader from '@/components/_cs/customers/CSCustomerCompactDetailHeader.vue';
import CSCustomerBasicStat from '@/components/_cs/customers/CSCustomerBasicStat.vue';
import CSCustomerExtendedStat from '@/components/_cs/customers/CSCustomerExtendedStat.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    entryDetail: {
      default: () => ({}),
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.entryDetail.date).format('D MMMM YYYY');
    },
    formattedTime() {
      return this.$moment(this.entryDetail.time).format('HH:mm');
    },
    warehouseName() {
      const list = this.availableWarehouse.filter((elm) => {
        if (elm.value && this.entryDetail.warehouse_id.toString() === elm.value.toString()) {
          return true;
        }
        return false;
      });
      if (list.length > 0) return list[0].text;
      return '';
    },
  },
  watch: {
    entryDetail() {
      this.entryDetailUpdated();
    },
  },
  async mounted() {
    this.entryDetailUpdated();

    const wareHouseRes = await this.$api.order.availableWarehouse();
    if (wareHouseRes.status === 200) {
      this.availableWarehouse = wareHouseRes.data;
    }

    const resCondition = await this.$api.order.actions.approveConditionCheck(
      this.entryDetail.id,
    );
    this.isConditionPassed = resCondition.data.canApprove;
  },
  data: () => ({
    isConditionPassed: false,
    failedApprovalItems: [],
    failedApprovalItemsColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.item.product_id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.item.product.name;
        },
      },
      requested: {
        title: 'พยายามสั่ง',
        align: 'right',
      },
      remaining: {
        title: 'มีเหลือ',
        align: 'right',
        computed(row) {
          return `<span class="text-danger">${row.remaining}</span>`;
        },
      },
    },
    tableColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.product.id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.product.name;
        },
      },
      percentage: {
        title: '% GP AVG Cost',
        align: 'right',
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      price: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed(row) {
          return Number(row.price) / Number(row.amount);
        },
      },
      totalPrice: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed(row) {
          return row.price;
        },
      },
    },
    tableData: {},

    actionStatusType: '',
    isLoading: false,

    customerStat: {},
    total: 0,

    availableWarehouse: [],
  }),
  methods: {
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.history.sellRecordsItem(this.entryDetail.entryNo);
    //   if (res.status === 200) {
    //     this.tableData = res.data.data;

    //     this.$emit('dataLoaded', this.tableData);
    //   }

    //   this.isLoading = false;
    // },

    async rejectSell() {
      try {
        // send request to the API
        const res = await this.$api.order.actions.reject(this.entryDetail.id);

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'admin.entryDetail.reject';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    async approveSellForce() {
      try {
        const res = await this.$api.order.actions.approve(this.entryDetail.id, true);

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'admin.entryDetail.approveforce';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    async approveSell() {
      try {
        const res = await this.$api.order.actions.approve(this.entryDetail.id);
        // alert(JSON.stringify(res));

        if (!res.data.success) {
          this.$modal.show('action-to-back-order');
          this.failedApprovalItems = res.data.items;
        }

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'admin.entryDetail.approve';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    // sendToCS() {
    //   // TODO: submit some data to API
    //   // ...
    //   this.$modal.show('action-status');
    //   this.actionStatusType = 'admin.entryDetail.admin';
    // },
    async sendToCS() {
      try {
        const res = await this.$api.order.actions.forward(this.entryDetail.id);
        // alert(JSON.stringify(res));

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'admin.entryDetail.cs';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },

    onModalCloseButtonClicked() {
      // close modal
      this.$modal.hide('action-status');
      this.$emit('actionPerformed');
    },

    entryDetailUpdated() {
      this.loadCustomerStat();

      this.tableData = this.entryDetail.products ? this.entryDetail.products : [];
      // alert(this.tableData);

      let total = 0;
      // let totalCommission = 0;
      for (let i = 0; i < this.entryDetail.products.length; i += 1) {
        const PROD = this.entryDetail.products[i];
        // console.log(PROD);
        total += (Number(PROD.price));
        // totalCommission += (Number(PROD.commission));
        // console.log(totalCommission);
      }

      this.total = total;
      // this.totalCommission = totalCommission;

      // console.log('updated!!');
      // console.log(`${total} ${totalCommission}`);
    },

    async loadCustomerStat() { // FIXME: looks like a deprecated method
      try {
        const res = await this.$api.customer.statForCustomerWithId(this.entryDetail.customer_id);
        this.customerStat = res.data.data;
      } catch (e) {
        console.warn(e);
      }
    },
  },
  components: {
    CSCustomerCompactDetailHeader,
    CSCustomerBasicStat,
    CSCustomerExtendedStat,
  },
};
</script>

<style lang="scss">
// .detail {}
</style>
